// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const materials = [
    {
        title: "Fibre naturale",
        text: "lână, mătase, bumbac, iută, sisal, cocos și lână de bambus",
    },
    {
        title: "Fibre sintetice",
        text: "poliamidă (nylon), polipropilenă (olefină), poliester (PET), poliacril și PVC",
    },
];

const cleaningMethods = [
    {
        title: "Curățarea petelor",
        text: "cheia este tapotarea, nu frecarea, folosirea soluțiilor potrivite tipului de pată și asigurarea unei uscări complete.",
    },
    {
        title: "Curățarea uscată",
        text: "se realizează sub formă de spray, praf, granule sau șamponare uscată pentru țesăturile delicate care nu suportă apa. Astfel se păstrează integritatea, culoarea și textura materialului, fără riscul de «intrare la apă».",
    },
    {
        title: "Curățarea în profunzime prin injecție-extracție",
        text: "mocheta este spălată până la baza stratului suport.",
    },
    {
        title: "Curățarea și igienizarea",
        text: "se realizează cu aparate cu abur și extracție.",
    },
];

function TestimonialsHome() {
    return (
        <MKBox component="section" pt={{ xs: 8, md: 10 }} pb={{ xs: 3, md: 5 }}>
            <Container>
                <Grid container item xs={12} lg={10} sx={{ mx: "auto" }}>
                    <MKTypography variant="h2" color="dark" mb={1} sx={{ textWrap: "balance" }}>
                        Care este specificul unei mochete, al unui covor sau al unei suprafețe
                        textile?
                    </MKTypography>
                    <MKTypography variant="h4" color="info" mb={3} sx={{ textWrap: "balance" }}>
                        Cum se întreține și cum se poate curăța?
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Atât întreținerea, cât și curățarea unei suprafețe textile se realizează în
                        funcție de specificul materialului, de stratul suport și de compoziția
                        materialelor care formează țesătura. Fiecare material oferă proprietăți
                        diferite de durabilitate, textură și rezistență la pete, precum și metode
                        proprii de întreținere și curățare.
                    </MKTypography>

                    <MKTypography
                        variant="h3"
                        color="dark"
                        mt={2}
                        mb={2}
                        sx={{ textWrap: "balance" }}
                    >
                        Materiale comune care stau la baza țesăturii
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={4}>
                        {materials.map(({ title, text }) => (
                            <MKTypography
                                component="li"
                                key={title}
                                variant="body1"
                                color="text"
                                mb={1}
                                sx={{ textWrap: "pretty" }}
                            >
                                <strong>{title}:</strong> {text}.
                            </MKTypography>
                        ))}
                    </MKBox>

                    <MKTypography variant="h3" color="dark" mb={2} sx={{ textWrap: "balance" }}>
                        Metode uscate sau umede
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Tehnicile de curățare și întreținere variază de la metode simple la metode
                        profesionale mecanizate și implică aspirarea temeinică, tratarea petelor cu
                        soluții specifice, curățarea, clătirea sau aspirarea finală.
                    </MKTypography>
                    <MKBox component="ul" pl={4} mb={4}>
                        {cleaningMethods.map(({ title, text }) => (
                            <MKTypography
                                component="li"
                                key={title}
                                variant="body1"
                                color="text"
                                mb={1.5}
                                sx={{ textWrap: "pretty" }}
                            >
                                <strong>{title}:</strong> {text}
                            </MKTypography>
                        ))}
                    </MKBox>

                    <MKTypography variant="h3" color="dark" mb={2} sx={{ textWrap: "balance" }}>
                        Periere rotativă sau circulară
                    </MKTypography>
                    <MKTypography variant="body1" color="text" mb={3} sx={{ textWrap: "pretty" }}>
                        Diferența principală dintre perierea rotativă și cea circulară, în spălarea
                        mochetei, constă în mecanismul de acțiune și intensitatea curățării. Peria
                        rotativă curăță în profunzime, ridicând fibrele, și este ideală pentru
                        mochete murdare sau cu praf acumulat. Peria circulară, prin mișcări
                        laterale, este mai blândă și excelentă pentru distribuirea detergentului și
                        curățarea delicată a zonelor sensibile, fără a deteriora mocheta.
                    </MKTypography>
                    <MKTypography variant="body1" color="text" sx={{ textWrap: "pretty" }}>
                        Alegerea depinde de gradul de murdărie: peria rotativă este folosită pentru
                        curățarea profundă, iar cea circulară pentru finisare și pete, ambele fiind
                        complementare într-un proces complet de curățare.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default TestimonialsHome;
